<script>
  import {mapGetters, mapActions} from 'vuex';
  import businessAreaUtils from "../BusinessAreaUtils";
  import utils from "../../utils";
  import apiService from 'src/services/ApiService';
  import RenderImagem from 'src/components/utils/RenderImagem'

  import utilsService from 'src/services/UtilsService';

  export default {
    components: {
      RenderImagem
    },
    computed: {
      ...mapGetters([
        'loggedUser'
      ])
    },
    methods: {
      getLogo(id) {
        return utils.getUrlBusinessAreaImage(id);
      }
    },
    mounted () {
      if (this.loggedUser.businessLines.length === 1) {
        this.$router.push('/businessArea/' + this.loggedUser.businessLines[0].id);
      }
    }
  }

</script>
<template>
  <div slot="body">

    <!-- TODO - ajustar espaçamento do topo -->
    <div class="row padding-top-50px">
      <div v-for="row in loggedUser.businessLines"
           :offset="index > 0 ? 2 : 0"
           class="col-xs-12 col-sm-6 col-md-3 col-lg-2 padding-top-10px">
        <RenderImagem
          height="height: 200px;"
          :router="{ name: 'SystemsList', params: { businessAreaId: row.id } }"
          :label="row.labelPt"
          :src="getLogo(row.id)"
        />
      </div>
    </div>

  </div>
</template>
<style scoped>
  .padding-top-50px{
    padding-top: 50px !important;
  }
  .padding-top-10px{
    padding-top: 15px;
    padding-bottom: 15px;
  }
  @media (min-width: 1200px) {
    .col-lg-2 {
      width: 25% !important;
    }
    @media (min-width: 1400px) {
      .col-lg-2 {
        width: 16.66667% !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// BusinessAreaList.vue?8c37098e